import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { StyledTableHead } from "./TableHead.styles";
import { TableHeadProps } from "./TableHead.types";

const TableHead: React.FC<TableHeadProps> = ({
	children,
	className,
	...props
}) => {
	const block = new BemIt("TableHead");

	return (
		<StyledTableHead className={addClass(className).after(block)} {...props}>
			{children}
		</StyledTableHead>
	);
};

export default TableHead;
